import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NetworkSymbologyCheckbox from '../NetworkSymbologyCheckbox/NetworkSymbologyCheckbox';
import { ALL_CATEGORIES } from '../constants';
import { sectors } from 'client/store/layersSlice/layersSlice';
import styles from './NetworkControls.module.scss';

const NetworkControls = ({
    categoriesForOwner,
    selectedAssetCategory,
    onlyHasOneCategory,
    hideAllOption,
    locale,
    owner,
    dataTestIdBase,
    onSelectAll,
    onSelectCategory
}) => {
    return (
        <hgroup>
            <h3><FormattedMessage id='isolatedViews.networks.heading' /></h3>
            {!hideAllOption && (
                <div className={styles.radio} data-testid={`${dataTestIdBase}.radio.all`}>
                    <input
                        type='radio'
                        value={ALL_CATEGORIES}
                        id={owner.dataProviderId + '-all'}
                        checked={selectedAssetCategory === ALL_CATEGORIES}
                        onChange={onSelectAll}
                    />
                    <label htmlFor={owner.dataProviderId + '-all'}>
                        <FormattedMessage id='isolatedViews.networks.all' />
                    </label>
                </div>
            )}

            {categoriesForOwner.map((categoryOption) => {
                const { id, category } = categoryOption;

                return (
                    <div key={owner.dataProviderId + '-' + id}>
                        <div className={styles.radio} data-testid={`${dataTestIdBase}.radio.${id.toLocaleLowerCase().replace(/\s+/g, '-')}`}>
                            <input
                                type='radio'
                                value={id}
                                checked={onlyHasOneCategory || selectedAssetCategory === id}
                                onChange={() => onSelectCategory(categoryOption)}
                                id={owner.dataProviderId + '-' + id}
                            />
                            {/* label id is for hiden assets label, everything else driven from map config */}
                            <label htmlFor={owner.dataProviderId + '-' + id}>
                                {categoryOption.labelId
                                    ? <FormattedMessage id={categoryOption.labelId} />
                                    : (category[locale] || category.en)}
                            </label>
                        </div>
                        <NetworkSymbologyCheckbox
                            category={category}
                            selectedCategory={selectedAssetCategory}
                            sector={sectors.GAS}
                            onlyHasOneCategory={onlyHasOneCategory}
                            ownerId={owner.dataProviderId}
                            dataTestId={`${dataTestIdBase}.checkbox.${sectors.GAS}`}
                        />
                        <NetworkSymbologyCheckbox
                            category={category}
                            selectedCategory={selectedAssetCategory}
                            sector={sectors.ELECTRICITY}
                            onlyHasOneCategory={onlyHasOneCategory}
                            ownerId={owner.dataProviderId}
                            dataTestId={`${dataTestIdBase}.checkbox.${sectors.ELECTRICITY}`}
                        />
                    </div>
                );
            })}
        </hgroup>
    );
};

NetworkControls.propTypes = {
    categoriesForOwner: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        category: PropTypes.object.isRequired,
        labelId: PropTypes.string
    })).isRequired,
    selectedAssetCategory: PropTypes.string.isRequired,
    onlyHasOneCategory: PropTypes.bool.isRequired,
    hideAllOption: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    owner: PropTypes.shape({
        dataProviderId: PropTypes.string.isRequired
    }).isRequired,
    dataTestIdBase: PropTypes.string.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onSelectCategory: PropTypes.func.isRequired
};

export default NetworkControls;
